import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import blogPosts from '../data/blogPosts';
import './Blog.css';

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const setPageMeta = (title, description) => {
  document.title = title;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', description);
};

const Blog = () => {
  useEffect(() => {
    setPageMeta(
      'Blog / Insights | Sapiencia.AI',
      'Latest AI security and compliance insights from Sapiencia.AI across healthcare and defense programs.'
    );
  }, []);

  return (
    <div className="blog-page">
      <Navbar />
      <main className="blog-main">
        <header className="blog-hero">
          <p className="eyebrow">Insights</p>
          <h1>Blog / Insights</h1>
          <p className="blog-subtitle">
            Perspectives on AI security, compliance, and mission-ready deployments for healthcare and defense teams.
          </p>
        </header>

        <section className="blog-grid" aria-label="Blog posts">
          {blogPosts.map((post) => (
            <article key={post.slug} className="blog-card">
              <div className="blog-card-meta">
                <span className="blog-card-category">{post.category}</span>
                <span className="blog-card-date">{formatDate(post.date)}</span>
                {post.readingTime && <span className="blog-card-time">{post.readingTime}</span>}
              </div>
              <h2>{post.title}</h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <div className="blog-card-tags">
                {post.tags?.map((tag) => (
                  <span key={tag} className="blog-tag">#{tag}</span>
                ))}
              </div>
              <Link to={`/blog/${post.slug}`} className="blog-card-link" aria-label={`Read ${post.title}`}>
                Read Article
              </Link>
            </article>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
